@if (errorsForField()) {
  <span class="help-block">
    <span>
      @switch (areTranslationKeys()) {
        @case (true) {
          <span>{{ errorTranslationKey(errorsForField()['error']) | translate:errorsForField() }}</span>
        }
        @case (false) {
          <span>{{ errorsForField()['error'] || errorsForField() }}</span>
        }
      }
    </span>
  </span>
} @else {
  <span class="help-block">&nbsp;</span>
}
